import { FileText, UploadCloud, Trophy } from "lucide-react";

const STEPS = [
  { icon: FileText, title: "Create JD & Competencies", desc: "Paste the job description and define a custom-weighted competency matrix in under a minute." },
  { icon: UploadCloud, title: "Drop Resume Batches", desc: "Drag-and-drop bulk PDF/DOCX resumes. Upload more anytime — each session becomes its own batch." },
  { icon: Trophy, title: "Get Ranked Leaderboards", desc: "hireqix scores every candidate with evidence, then ranks them into a leaderboard with full reports." },
];

export default function LandingHowItWorks() {
  return (
    <section id="how-it-works" className="bg-muted/30 px-4 py-20 sm:px-6 sm:py-28 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mx-auto max-w-xl text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">How it works</span>
          <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">Three steps to your shortlist</h2>
        </div>

        <div className="mt-12 grid gap-8 sm:grid-cols-3" data-testid="landing-how-it-works">
          <div className="pointer-events-none absolute left-0 right-0 top-[92px] hidden border-t border-dashed border-primary/30 sm:block" style={{ marginLeft: "16.5%", marginRight: "16.5%" }} />
          {STEPS.map((s, idx) => (
            <div key={s.title} className="relative text-center animate-in fade-in-0 slide-in-from-bottom-2 duration-500" style={{ animationDelay: `${idx * 100}ms` }}>
              <div className="relative z-10 mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/15 text-primary ring-8 ring-muted/30 shadow-md glossy-card">
                <s.icon className="h-6 w-6" />
              </div>
              <div className="mx-auto mt-4 flex h-6 w-6 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground">{idx + 1}</div>
              <h3 className="mt-3 font-heading text-lg font-semibold">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
